/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

export const addressToString = (address) => {
  // handle null
  if (!address) {
    return "";
  }

  // prepare builder variables
  let locationString = "";
  let count = 0;

  // iterate over keys
  ["street", "city", "state", "zip", "country"].forEach((item) => {
    const subString = address[item];
    if (subString) {
      if (count > 0) {
        locationString += ", ";
      }
      locationString += address[item];
      count++; 
    }
  });

  return locationString;
};

export const locationAddressToReviewSearch = (location = null, name = null, address = null) => {
  let text = "";
  if (location?.name != null) {
    text += ` ${location.name}`
  }

  if (location?.address?.street != null) {
    text += ` ${location.address.street}`
  }

  if (location?.address?.city != null) {
    text += ` ${location.address.city}`
  }

  if (location?.address?.state != null) {
    text += ` ${location.address.state}`
  }

  if (location?.address?.zip != null) {
    text += ` ${location.address.zip}`
  }

  if (location?.address?.country != null) {
    text += ` ${location.address.country}`
  }

  // Set if location object not passed

  if (name != null) {
    text += ` ${name}`
  }

  if (address?.street != null) {
    text += ` ${address.street}`
  }

  if (address?.city != null) {
    text += ` ${address.city}`
  }

  if (address?.state != null) {
    text += ` ${address.state}`
  }

  if (address?.zip != null) {
    text += ` ${address.zip}`
  }

  if (address?.country != null) {
    text += ` ${address.country}`
  }

  return text.replace(/\s+/g, ' ').trim();
}